module.exports = __webpack_public_path__ + "img/two.d62d8a5f.gif";